import { render, staticRenderFns } from "./ListGroupDivider.vue?vue&type=template&id=796eedfa&"
import script from "./ListGroupDivider.vue?vue&type=script&lang=js&"
export * from "./ListGroupDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports